<template>
  <span>{{ time }}</span>
</template>

<script lang="ts" setup>
  import { onBeforeUnmount, onMounted, ref } from 'vue';
  import { DateFormatter, recursiveTimeout } from '@mts-fe/utils';

  defineOptions({ name: 'NowTime' });

  const time = ref('-');
  let timer: { stop: () => void };
  onMounted(() => {
    timer?.stop();
    timer = recursiveTimeout(
      () => {
        if (document.hidden) return;
        time.value = DateFormatter.TS(new Date());
      },
      1e3,
      { immediate: true },
    );
  });

  onBeforeUnmount(() => timer?.stop());
</script>
